var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.volumes),function(volume){return _c('div',{key:volume.branchID},[_c('color-feature',{attrs:{"volume":volume,"meshMaterial":_vm.getMeshMaterialFromVolume(volume)}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }